<template>
  <div class="user-basic-info">
    <div class="user-basic-info-avatar">
      <div class="avatar" @click="clickHeadImg">
        <div class="img" :style="avatarStyle"></div>
        <div v-if="!isMobile && isEditMode" class="mask"></div>
      </div>
      <div v-if="!isMobile && isEditMode" class="text" @click="clickHeadImg">上传照片</div>
    </div>
    <div class="main">
      <div class="name">
        <span @click="clickName">{{ name }}</span>
        <EditButton v-if="isEditMode" class="edit" @click="clickEdit"></EditButton>
      </div>
      <div class="title" @click="clickTitle">{{title}}</div>
    </div>
    <div class="stat">
      <PageStat
        :data="stat"
        @clickAnswer="clickAnswer"
        @clickReceive="clickReceive"
        @clickAnswerRate="clickAnswerRate"
        @clickPv="clickPv"
      ></PageStat>
    </div>
    <div class="loc">
      <div style="display: flex">
        <i class="icon icon-pr_phone_icon_position"></i>
        <span>&nbsp;&nbsp;</span>
        <span v-for="(v, i) in loc" :key="i">&nbsp;{{v}}</span>
      </div>
    </div>
    <div v-if="state===0 && isShowSend">
      <BaseButton2 @click="clickSend" style="width: 130px;box-shadow: 0 10px 40px -10px rgba(65,106,240,0.8);">{{lang.send}}</BaseButton2>
    </div>
  </div>
</template>

<script>
// import _ from 'lodash'
import { mapState } from 'vuex'
import PageStat from './PageStat.vue'

import {
  BaseButton2,
  EditButton
} from '@/components'

export default {
  components: {
    PageStat,
    BaseButton2,
    EditButton
  },
  props: {
    lang: {
      type: Object,
      default () {
        return {
          edit: '修改',
          send: '投递给TA'
        }
      }
    },
    isEditMode: {
      type: Boolean,
      default: false
    },
    isShowSend: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMobile () { return this.$store.getters.isMobile },
    avatarStyle () {
      let str = ''
      if (!this.isMobile && this.isEditMode) str += `cursor: pointer`
      const size = (this.isMobile) ? 100 : 120
      return `${str};width:${size}px;height:${size}px;background-image:url('${this.img}')`
    },
    ...mapState('api/dartcome', {
      name: ({ card }) => card.name,
      title: ({ card }) => card.title,
      img: ({ card }) => card.head_image_url || 'https://az.cdn.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_default_image_big.png',
      stat: ({ pv, investor }) => {
        const answer = investor.deliverFinish || 0
        const receive = investor.deliverCount || 0
        let rate = investor.deliverAnswerRate
        if (rate === null) { // eslint-disable-line camelcase
          rate = receive ? answer / receive : 0
          rate = Math.round(rate * 100) // eslint-disable-line camelcase
        }
        return {
          answer,
          receive,
          answer_rate: rate,
          pv: pv || 0
        }
      },
      loc: ({ province, city }) => [province, city],
      state: ({ investor }) => investor.state
    })
  },
  methods: {
    clickHeadImg () { this.$emit('clickHeadImg') },
    clickName () { this.$emit('clickName') },
    clickTitle () { this.$emit('clickTitle') },
    clickSend () { this.$emit('clickSend') },
    clickAnswer () { this.$emit('clickAnswer') },
    clickReceive () { this.$emit('clickReceive') },
    clickAnswerRate () { this.$emit('clickAnswerRate') },
    clickPv () { this.$emit('clickPv') },
    clickEdit () { this.$emit('clickEdit') }
  }
}
</script>

<style lang="postcss" scoped>
@import "var.css";
.user-basic-info {
  width: 100%;
  margin: 0 auto 15px auto;
  text-align: center;

  & .user-basic-info-avatar {
    @media (--mediaPc) {
      margin-top: calc(- 120px / 2);
    }
    @media (--mediaMobile) {
      margin-top: calc(- 100px / 2);
    }
    position: relative;
    & .avatar {
      position: relative;
      margin: auto;
      border-radius: 100px;
      @media (--mediaPc) {
        width: 120px;
        height: 120px;
      }
      @media (--mediaMobile) {
        width: 100px;
        height: 100px;
      }
      & > .img {
        background-size: cover;
        background-position: center;
        border-radius: 100px;
      }
      & .mask {
        position: absolute;
        margin: auto;
        top: 0;
        border-radius: 100px;
        background-color: rgba(0, 0, 0, .5);
        cursor: pointer;
        @media (--mediaPc) {
          width: 120px;
          height: 120px;
        }
        @media (--mediaMobile) {
          width: 100px;
          height: 100px;
        }
      }
    }
    & .text {
      position: absolute;
      text-align: center;
      width: 100%;
      color: var(--colorWhite);
      cursor: pointer;
      @media (--mediaPc) {
        top: 54px;
        font-size: var(--textSize4);
      }
      @media (--mediaMobile) {
        top: 42px;
        font-size: var(--textSize4Mobile);
      }
    }
  }
  & .main {
    @media (--mediaPc) {
      margin: 13px 0;
    }
    @media (--mediaMobile) {
      margin-top: calc(40px / var(--scaleMobile));
      margin-bottom: calc(24px / var(--scaleMobile));
    }

    & .name {
      position: relative;
      max-width: 1024px;
      margin: auto;
      @media (--mediaPc) {
        font-size: var(--textSize0);
      }
      @media (--mediaMobile) {
        font-size: var(--textSize1Mobile);
      }
    }
    & .edit {
      position: absolute;
      right: 20px;
    }
    & .title {
      color: var(--colorGray0);
      @media (--mediaPc) {
        margin-top: 13px;
        font-size: var(--textSize3);
      }
      @media (--mediaMobile) {
        margin-top: calc(16px / var(--scaleMobile));
        font-size: var(--textSize4Mobile);
      }
    }
  }
  & .stat {

  }
  & .loc {
    display: inline-block;
    color: var(--color6);
    @media (--mediaPc) {
      margin: 25px;
    }
    @media (--mediaMobile) {
      margin: calc(30px / var(--scaleMobile));
      font-size: var(--textSize5Mobile);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/containers/user/BasicInfo.vue